import React, { FC } from "react"
import "./rightbar.scss"

const RightSidebar: FC= () => {
  return <></>
}

export default RightSidebar;
